@if (!item.hidden) {
  @if (item.url && !item.external) {
    <li [ngClass]="item.classes!" [routerLinkActive]="['active']">
      <a class="nav-link" id="item.id" [target]="item.target ? '_blank' : '_self'" [routerLink]="[item.url, item.id]" (click)="closeOtherMenu()">
        @if (item.icon) {
          <span class="coded-micon">
            <svg class="pc-icon">
              <use attr.xlink:href="assets/fonts/custom-icon.svg{{ item.icon }}"></use>
            </svg>
          </span>
        }
        @if (item.icon) {
          <span class="coded-mtext">{{ item.title }}</span>
        } @else {
          {{ item.title }}
        }
      </a>
    </li>
  } @else if (item.url && item.external) {
    <li [ngClass]="item.classes!">
      <a [target]="item.target ? '_blank' : '_self'" [href]="item.url" id="item.id">
        @if (item.icon) {
          <span class="coded-micon">
            <svg class="pc-icon">
              <use attr.xlink:href="assets/fonts/custom-icon.svg{{ item.icon }}"></use>
            </svg>
          </span>
        }
        @if (item.icon) {
          <span class="coded-mtext">{{ item.title }}</span>
        } @else {
          {{ item.title }}
        }
      </a>
    </li>
  }
}
